const financeExample = `
 <div className="mt-2">
  <p><strong style="color: rgb(16, 65, 130);">Contexte :</strong></p>
  <ul>
    <li>Acteur majeur du secteur Assurances N-2 du Directeur Financier 1.5 Mds € de budget coût à piloter</li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Périmètre :</strong></p>
  <ul>
    <li>Ensemble des coûts de la société X (1.5 Mds €) 3 Equipes à piloter, soit ~30 collaborateurs Reporting
      au COMEX et au Groupe en Allemagne
    </li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Objectifs :</strong></p>
  <ul>
    <li>Piloter et réduire les coûts (cost cutting) Mise en place de SAP (ERP) et SAS FM (EPM)</li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Réalisations :</strong></p>
  <ul>
    <li>Piloter et réduire les coûts</li>
    <li>Challenging des propositions budgétaires des différents départements Présentation au COMEX de mesures
      de réduction des coûts Refonte des clefs d’allocation des coûts vers les lignes de Business Mise en
      place de SAP et SAS FM
    </li>
    <li>Audit de faisabilité et de pertinence du nouvel outil par rapport aux besoins</li>
    <li>Pilotage des travaux préparatoires Réunions d’arbitrages avec l’équipe projet et les « stakeholders
      (fiscalité, comptabilité, actuaires….) Suivi de la phase de recette Accompagnement au changement de
      l’équipe
    </li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Résultats :</strong></p>
  <ul>
    <li>Base de coûts réduite de -20% Mise en place de SAP et SAS FM réussie</li>
  </ul>
</div>
`

export {financeExample}